import React from 'react'

function Coverflow() {
  return (
    <div className="big-display">
        <span className='heading1'>Cover Flow</span>
    </div>
  )
}

export default Coverflow